import { render } from "./TheDialogError.vue?vue&type=template&id=12985a56&scoped=true&ts=true"
import script from "./TheDialogError.vue?vue&type=script&lang=ts"
export * from "./TheDialogError.vue?vue&type=script&lang=ts"

import "./TheDialogError.vue?vue&type=style&index=0&id=12985a56&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12985a56"]])

export default __exports__